import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    children: [
      { component: () => import('pages/auth/index'), meta: { public: true }, name: 'auth', path: 'auth' },
      {
        component: () => import('pages/auth/error.vue'),
        meta: { public: true },
        name: 'auth-error',
        path: 'auth/error',
      },
      { component: () => import('pages/login.vue'), meta: { public: true }, name: 'login', path: 'login' },
      {
        component: () => import('pages/login-token.vue'),
        meta: { public: true },
        name: 'login-token',
        path: 'login/token',
      },
      { name: 'orders', path: 'orders', redirect: { name: 'dashboard' } },
      { component: () => import('pages/orders/[id].vue'), name: 'order', path: 'orders/:id' },
      { component: () => import('pages/orders/magento/[id].vue'), name: 'order-by-increment-id', path: 'orders/magento/:id' },
      { component: () => import('pages/dashboard.vue'), name: 'dashboard', path: 'dashboard' },
      { component: () => import('pages/forms.vue'), name: 'forms', path: 'forms' },
      { component: () => import('pages/companies/index.vue'), name: 'companies', path: 'companies' },
      { component: () => import('pages/invoicing/index.vue'), name: 'invoicing', path: 'invoicing' },
      {
        children: [
          { component: () => import('pages/companies/[id]/index.vue'), name: 'company', path: '' },
          {
            component: () => import('pages/companies/[id]/blacklist.vue'),
            name: 'company-blacklist',
            path: 'blacklist',
          },
          {
            component: () => import('pages/companies/[id]/feature-flags.vue'),
            name: 'company-feature-flags',
            path: 'feature-flags',
          },
          {
            component: () => import('pages/companies/[id]/event.vue'),
            name: 'company-event',
            path: 'events/:eventId',
          },
          {
            component: () => import('pages/companies/[id]/events.vue'),
            name: 'company-events',
            path: 'events',
          },
          {
            component: () => import('pages/companies/[id]/orders.vue'),
            name: 'company-orders',
            path: 'orders',
          },
          {
            component: () => import('pages/companies/[id]/settings.vue'),
            name: 'company-settings',
            path: 'settings',
          },
        ],
        component: () => import('pages/companies/[id]/route.vue'),
        name: 'company-wrapper',
        path: 'companies/:id',
      },
      { component: () => import('pages/merchants/index.vue'), name: 'merchants', path: 'merchants' },
      { component: () => import('pages/merchants/new.vue'), name: 'merchant-new', path: 'merchants/new' },
      {
        children: [
          { component: () => import('pages/merchants/[id]/index.vue'), name: 'merchant', path: '' },
          {
            component: () => import('pages/merchants/[id]/offer-settings.vue'),
            name: 'merchant-offer-settings',
            path: 'offer-settings',
          },
          {
            component: () => import('pages/merchants/[id]/online-codes/index.vue'),
            name: 'merchant-online-codes',
            path: 'online-codes',
          },
          {
            component: () => import('pages/merchants/[id]/online-codes/upload.vue'),
            name: 'merchant-online-codes-upload',
            path: 'online-codes/upload',
          },
          {
            component: () => import('pages/merchants/[id]/transactions.vue'),
            name: 'merchant-transactions',
            path: 'transactions',
          },
          {
            component: () => import('pages/merchants/[id]/user-accounts.vue'),
            name: 'merchant-user-accounts',
            path: 'user-accounts',
          },
          {
            component: () => import('pages/merchants/[id]/redeem-code.vue'),
            name: 'merchant-redeem-code',
            path: 'redeem-code',
          },
        ],
        component: () => import('pages/merchants/[id]/route.vue'),
        name: 'merchant-wrapper',
        path: 'merchants/:id',
      },
      { component: () => import('pages/media/index.vue'), name: 'media', path: 'media' },
      { component: () => import('pages/media/[id].vue'), name: 'media-edit', path: 'media/:id' },
      { component: () => import('pages/download-center/index.vue'), name: 'download-center', path: 'download-center' },
      {
        component: () => import('pages/download-center/checks.vue'),
        name: 'download-center-checks',
        path: 'download-center/checks',
      },
      {
        component: () => import('pages/download-center/merchant-online-codes.vue'),
        name: 'download-center-merchant-online-codes',
        path: 'download-center/merchant-online-codes',
      },
      {
        component: () => import('pages/download-center/merchant-check-transactions.vue'),
        name: 'download-center-merchant-check-transactions',
        path: 'download-center/merchant-check-transactions',
      },
      { component: () => import('pages/checks/[id].vue'), name: 'check', path: 'checks/:id' },
      { component: () => import('pages/events/index.vue'), name: 'events', path: 'events' },
      { component: () => import('pages/events/[id].vue'), name: 'event', path: 'events/:id' },
      { component: () => import('pages/sentry.vue'), name: 'sentry-test', path: 'sentry' },
      { component: () => import('pages/feature-flags/index.vue'), name: 'feature-flags', path: 'feature-flags' },
      { component: () => import('pages/buried-services/index.vue'), name: 'buried-services', path: 'buried-services' },
      { component: () => import('pages/system/index.vue'), name: 'system', path: 'system' },
      { component: () => import('pages/promos/index.vue'), name: 'promos', path: 'promos' },
      { component: () => import('pages/promos/toplistings/index.vue'), name: 'toplistings', path: 'promos/toplistings' },
      { component: () => import('pages/promos/toplistings/[id].vue'), name: 'toplisting', path: 'promos/toplistings/:id' },
      {
        component: () => import('pages/promos/in-page-promotions/index.vue'),
        name: 'in-page-promotions',
        path: 'promos/in-page-promotions',
      },
      {
        component: () => import('pages/promos/in-page-promotions/[id].vue'),
        name: 'in-page-promotion',
        path: 'promos/in-page-promotions/:id',
      },
      {
        component: () => import('pages/promos/redemption-news/index.vue'),
        name: 'redemption-news',
        path: 'promos/redemption-news',
      },
      {
        component: () => import('pages/promos/redemption-news/[id].vue'),
        name: 'redemption-news-item',
        path: 'promos/redemption-news/:id',
      },
      { component: () => import('pages/promos/raffles/index.vue'), name: 'raffles', path: 'promos/raffles' },
      { component: () => import('pages/promos/raffles/[id].vue'), name: 'raffle', path: 'promos/raffles/:id' },
      { component: () => import('pages/entities/index.vue'), name: 'entities', path: 'entities' },
      { path: 'settings', redirect: { name: 'entities' } },
      { component: () => import('pages/industries/index.vue'), name: 'industries', path: 'industries' },
      { component: () => import('pages/industries/[id].vue'), name: 'industry', path: 'industries/:id' },
      { component: () => import('pages/insight-types/index.vue'), name: 'insight-types', path: 'insight-types' },
      { component: () => import('pages/insight-types/[id].vue'), name: 'insight-type', path: 'insight-types/:id' },
    ],
    component: () => import('layouts/layout.vue'),
    path: '/',
    redirect: { name: 'login' },
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    component: () => import('pages/error.vue'),
    path: '/:catchAll(.*)*',
  },
]

export default routes
